module.exports = __webpack_public_path__ + "img/inMovement.847ba283.png";